import Header from "./Header";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showBack = location.pathname !== "/categories";

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header stays at the top; not part of the scrolled area */}
      <header className="shrink-0">
        <Header />
      </header>

      {/* Main content area is the scroll container */}
      <section className="relative max-w-7xl mx-auto w-full flex-1 min-h-0 overflow-y-scroll pb-24">
        {showBack && (
          <>
            {/* Mobile back button */}
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="fixed left-5 bottom-5 sm:hidden p-4 rounded-full bg-[#0A0D36] text-white shadow-lg opacity-50 hover:opacity-100"
            >
              <IoMdArrowBack className="text-white" />
            </button>
            {/* Desktop back button */}
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="hidden fixed left-5 2xl:left-20 top-30 sm:block p-4 rounded-full bg-[#0A0D36] opacity-50 hover:opacity-100 text-white shadow-lg"
            >
              <IoMdArrowBack className="text-white" />
            </button>
          </>
        )}

        <Outlet />
      </section>
    </div>
  );
};

export default Layout;
